import dynamic from "next/dynamic";

export const DynamicHero029 = dynamic(() => import("./Hero029"), {
  suspense: true,
});
